import React, { useState } from "react";
import {
  GoogleMap,
  useJsApiLoader,
  Marker,
  InfoWindow,
} from "@react-google-maps/api";
import { Box, Typography, Button } from "@mui/material";
import bgBlock from "../assets/berel/bg.jpg";

const containerStyle = {
  width: "100%",
  height: "100%",
  minHeight: "400px",
  borderRadius: "8px",
};

// Global styles to override Google Maps default InfoWindow padding and close button
const globalMapStyles = `
  /* Remove all padding and set border radius for the main InfoWindow container */
  .gm-style-iw {
    padding: 0 !important;
    border-radius: 12px !important;
    overflow: hidden !important;
  }
  
  /* Target the exact internal container Google uses to wrap content */
  .gm-style-iw-c {
    padding: 0 !important;
    border-radius: 12px !important;
    overflow: hidden !important;
  }
  
  /* Target the content wrapper inside the InfoWindow */
  .gm-style-iw-d {
    overflow: hidden !important;
    padding: 0 !important;
    margin: 0 !important;
    border-radius: 12px !important;
    /* Ensure no scrollbars */
    max-height: none !important;
  }
  
  /* Remove any nested padding/margin that might be pushing the image down */
  .gm-style .gm-style-iw-c .gm-style-iw-d {
    overflow: hidden !important;
    padding: 0 !important;
  }
  
  .gm-style-iw-d > div {
    margin: 0 !important;
    padding: 0 !important;
  }

  /* Force the close button wrapper to absolute positioning so it doesn't affect document flow */
  button.gm-ui-hover-effect {
    position: absolute !important;
    top: 6px !important;
    right: 6px !important;
    background-color: rgba(0, 0, 0, 0.4) !important;
    border-radius: 50% !important;
    width: 24px !important;
    height: 24px !important;
    z-index: 10 !important;
    margin: 0 !important;
    padding: 0 !important;
    border: none !important;
  }
  
  /* Style the actual X icon inside the close button */
  button.gm-ui-hover-effect span {
    width: 14px !important;
    height: 14px !important;
    margin: 5px !important;
    background-color: white !important;
  }
  
  /* Hide the default white background block for the close button if Google injects it */
  .gm-style-iw-tc::after {
    /* Keeps the little pointer arrow pointing to the pin */
  }
`;

// Center map on Monterrey
const center = {
  lat: 25.6866,
  lng: -100.3161,
};

export const berelStores = [
  // Zona Centro y Mitras
  { id: 1, name: "Pinturas Berel - Madero", zone: "Zona Centro y Mitras", address: "Av. Francisco I. Madero 1008 pte, Centro.", hours: "Lunes a viernes 7:30–17:30, sábado 8:00–13:30", lat: 25.6811, lng: -100.3204 },
  { id: 2, name: "Pinturas Berel - Centro", zone: "Zona Centro y Mitras", address: "Eje Metropolitano 26, Centro.", hours: "Lunes a viernes 8:30–18:00, sábado 9:00–15:00", lat: 25.6720, lng: -100.3110 },
  { id: 3, name: "Pinturas Berel - Colón", zone: "Zona Centro y Mitras", address: "Av. Cristóbal Colón 1610, Centro.", hours: "Lunes a viernes 8:30–18:00, sábado 8:30–14:00", lat: 25.6865, lng: -100.3265 },
  { id: 4, name: "Pinturas Berel - Colegio Civil", zone: "Zona Centro y Mitras", address: "Calle Colegio Civil 819, Centro.", hours: "Lunes a viernes 8:30–17:50, sábado 8:30–16:30", lat: 25.6795, lng: -100.3150 },
  { id: 5, name: "Pinturas Berel - Mitras Centro", zone: "Zona Centro y Mitras", address: "Av. Prof. Moisés Sáenz 1337, Mitras Centro.", hours: "Lunes a viernes 8:00–19:00, sábado 8:00–17:00, domingo 9:00–14:00", lat: 25.6895, lng: -100.3450 },

  // Zona Cumbres y Poniente
  { id: 6, name: "Pinturas Berel - Anillo Periférico", zone: "Zona Cumbres y Poniente", address: "Av. Anillo Periférico 101, Rincón de San Jerónimo.", hours: "Lunes a viernes 7:30–19:00, sábado 7:30–14:00", lat: 25.6730, lng: -100.3600 },
  { id: 7, name: "Berel - Sucursal Cumbres", zone: "Zona Cumbres y Poniente", address: "Av. Paseo de los Leones, esq. Av Hacienda de Peñuelas 2801, Cumbres Las Palmas Residencial.", hours: "Lunes a viernes 8:00–18:00, sábado 8:00–16:00", lat: 25.7380, lng: -100.3850 },
  { id: 8, name: "Pinturas Berel - Cumbres 3er Sector", zone: "Zona Cumbres y Poniente", address: "Av. Paseo de los Leones 2417.", hours: "Lunes a sábado 8:00–20:00, domingo 8:00–17:00", lat: 25.7280, lng: -100.3700 },
  { id: 9, name: "Pinturas Berel - 7a. Avenida", zone: "Zona Cumbres y Poniente", address: "7a. Avenida #403-D-1° Sector, Cumbres.", hours: "Lunes a sábado 8:00–19:50, domingo 8:00–16:00", lat: 25.7180, lng: -100.3550 },
  { id: 10, name: "Pinturas Berel - San Francisco de Asís", zone: "Zona Cumbres y Poniente", address: "Av. Abraham Lincoln 4657.", hours: "Lunes a domingo 8:30–18:00", lat: 25.7250, lng: -100.3552 }
];

const MapComponent = () => {
  const { isLoaded } = useJsApiLoader({
    id: "google-map-script",
    // Replace with your actual Google Maps API Key
    googleMapsApiKey: process.env.REACT_APP_GOOGLE_MAPS_API_KEY,
  });

  const [selectedStore, setSelectedStore] = useState(null);

  const onLoad = React.useCallback(function callback(map) {
    // You could adjust bounds here if needed
  }, []);

  const onUnmount = React.useCallback(function callback(map) {
    
  }, []);

  if (!isLoaded)
    return (
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          height: "100%",
          minHeight: "400px",
          bgcolor: "#f0f0f0",
        }}
      >
        Cargando mapa...
      </Box>
    );

  return (
    <GoogleMap
      mapContainerStyle={containerStyle}
      center={center}
      zoom={11}
      onLoad={onLoad}
      onUnmount={onUnmount}
      options={{
        mapTypeControl: false,
        streetViewControl: false,
        fullscreenControl: false,
      }}
    >
      <style>{globalMapStyles}</style>
      
      {berelStores.map((store) => (
        <Marker
          key={store.id}
          position={{ lat: store.lat, lng: store.lng }}
          onClick={() => setSelectedStore(store)}
          icon={{
            url: require("../assets/berel/logo.png"),
            scaledSize: new window.google.maps.Size(36, 36),
            origin: new window.google.maps.Point(0, 0),
            anchor: new window.google.maps.Point(18, 18),
          }}
        />
      ))}

      {selectedStore && (
        <InfoWindow
          position={{ lat: selectedStore.lat, lng: selectedStore.lng }}
          onCloseClick={() => setSelectedStore(null)}
          options={{
            pixelOffset: new window.google.maps.Size(0, -20)
          }}
        >
          <Box sx={{ 
            minWidth: "200px", 
            maxWidth: "250px", 
            overflow: "hidden", 
            borderRadius: "8px" 
          }}>
            {/* Header Image */}
            <Box
              sx={{
                width: "100%",
                height: "80px",
                backgroundImage: `url(${bgBlock})`,
                backgroundSize: "cover",
                backgroundPosition: "center",
                position: "relative",
              }}
            >
              {/* Overlay to match the store card look */}
              <Box
                sx={{
                  position: "absolute",
                  top: 0,
                  left: 0,
                  right: 0,
                  bottom: 0,
                  backgroundColor: "rgba(0, 163, 224, 0.65)", // Match the cyan overlay of store cards
                  zIndex: 1,
                }}
              />
            </Box>

            {/* Content Container */}
            <Box sx={{ p: 1.5, textAlign: "center", bgcolor: "white" }}>
              <Typography variant="subtitle2" fontWeight="bold" sx={{ mb: 0.5, color: "#1a1a1a" }}>
                {selectedStore.name}
              </Typography>
              <Typography variant="body2" sx={{ color: "#666", mb: 0.5, fontSize: "0.8rem", lineHeight: 1.2 }}>
                {selectedStore.address}
              </Typography>
              <Typography variant="body2" sx={{ color: "#00A3E0", mb: 1.5, fontSize: "0.75rem", fontWeight: "bold" }}>
                {selectedStore.hours}
              </Typography>
              <Button 
                variant="contained" 
                size="medium" 
                fullWidth
                sx={{ 
                  backgroundColor: "#ffffff", 
                  color: "#00A3E0", 
                  fontWeight: "bold",
                  fontSize: "1rem", 
                  py: 1, 
                  borderRadius: "24px", 
                  textTransform: "none",
                  boxShadow: "0 4px 8px rgba(0,0,0,0.15)", 
                  "&:hover": {
                    backgroundColor: "#f3f4f6", 
                  },
                  mt: 1
                }}
                onClick={() => {
                  window.location.href = "https://pide.mennu.mx/berel";
                }}
              >
                Ir a tienda
              </Button>
            </Box>
          </Box>
        </InfoWindow>
      )}
    </GoogleMap>
  );
};

export default React.memo(MapComponent);
